'use client';

import React from 'react';
import { useLanguage, Language } from '@/context/LanguageContext';
import AppImage from '@/components/ui/AppImage';

const languages: { code: Language; label: string; countryCode: string; flagEmoji: string }[] = [
  { code: 'tr', label: 'TR', countryCode: 'tr', flagEmoji: '🇹🇷' },
  { code: 'en', label: 'EN', countryCode: 'gb', flagEmoji: '🇬🇧' },
  { code: 'ru', label: 'RU', countryCode: 'ru', flagEmoji: '🇷🇺' },
  { code: 'es', label: 'ES', countryCode: 'es', flagEmoji: '🇪🇸' },
];

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  return (
    <div
      className="fixed top-5 right-5 z-50 flex items-center gap-1 p-1 rounded-2xl"
      style={{
        background: 'rgba(13,17,23,0.85)',
        border: '1px solid rgba(200,206,214,0.12)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
      }}
    >
      {languages.map((lang) => {
        const isActive = language === lang.code;
        return (
          <button
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-bold uppercase tracking-wider transition-all duration-200"
            style={{
              background: isActive
                ? 'linear-gradient(135deg, rgba(99,179,237,0.25), rgba(167,139,250,0.25))'
                : 'transparent',
              border: isActive ? '1px solid rgba(99,179,237,0.4)' : '1px solid transparent',
              color: isActive ? '#EDF2F7' : 'rgba(200,206,214,0.45)',
              cursor: 'pointer',
            }}
            aria-label={`Switch to ${lang.label}`}
          >
            <AppImage
              src={`https://flagcdn.com/w20/${lang.countryCode}.png`}
              alt={`${lang.label} flag`}
              width={20}
              height={15}
              className="inline-flex items-center flex-shrink-0"
              style={{ borderRadius: 3 }}
            />
            <span className="text-sm leading-none">{lang.label}</span>
          </button>
        );
      })}
    </div>
  );
}
